/* eslint-disable eqeqeq */
import React, { useState } from "react"
import { Row, Col } from 'antd'
import { useWindowWidth } from '@react-hook/window-size'
import * as d3 from 'd3'
import _ from 'lodash';

import BadgeChart from '../charts/BadgeChart/BadgeChartComponent'
import politiStats from '../../assets/data/politiStats.json'
import Section from './SectionHighlight'

function BadgeChartComponent() {
  const width = useWindowWidth({wait: 1});
  //const [selectedYear, setSelectedYear] = useState(null);
  //const [selectedPresident, setSelectedPresident] = useState(null);
  //const [presidentStats, setPresidentStats] = useState(null);
  const [presidents] = useState(politiStats);
  const maxCount = _.maxBy(politiStats, 'full.count').full.count
  const [dateRange] = useState(d3.extent(_(politiStats)
    .map('monthly')
    .flatMap()
    .map(m => new Date(m.date))
    .value())
  )
  const [sectionsProgress, setSectionsProgress] = useState({});
  const [highlight, setHighlight] = useState(null);

  const setSectionProgress = (id, progress) => {
    sectionsProgress[id] =  { progress };
    setSectionsProgress({...sectionsProgress});
    setHighlight(id)
  } 
  
  /*useEffect(() => {
    setMaxCount(Math.max(...politiStats.map(d => {
      if(selectedYear && selectedYear !== 'null') {
        const y = d.yearly.find(y => moment(y.date).year() == selectedYear);
        return y ? y.count : 0
      }
      return d.full.count
    })))
  }, [selectedYear])*/

  /*useEffect(() => {
    if(selectedPresident) {
      const stats = selectedYear ? selectedPresident.yearly.find(y => moment(y.date).year() == selectedYear) : selectedPresident.full;
      setPresidentStats(stats)
    } else {
      setPresidentStats(null)
    }
  }, [selectedYear, selectedPresident])*/

  return (
    <div style={{ marginBottom: 40 }}>
      {/*<Tabs defaultValue={selectedYear} onChange={setSelectedYear}>
        <Tabs.TabPane tab="Last 5 years" key={null} />
        <Tabs.TabPane tab="2015" key="2015" />
        <Tabs.TabPane tab="2016" key="2016" />
        <Tabs.TabPane tab="2017" key="2017" />
        <Tabs.TabPane tab="2018" key="2018" />
        <Tabs.TabPane tab="2019" key="2019" />
        <Tabs.TabPane tab="2020" key="2020" />
      </Tabs>*/}

      <div>
        <div style={{ marginBottom: 40, position: 'relative' }}>
          { width <= 900 && <div style={{ padding: width >= 900 ? 0 : 16, marginBottom: width >= 900 ? '15vh' : 0 }}>
              <h1>Opposing strategies</h1>
              <p>Georges-Louis Bouchez is therefore the most active president on Twitter, while Bart De Wever is the most relayed.</p> 
            </div>
          } 
          <div className="graphic">
            { width >= 900 && <div style={{ padding: width >= 900 ? 0 : 16, marginBottom: width >= 900 ? '15vh' : 0 }}>
                <h1>Opposing strategies</h1>
                <p>Georges-Louis Bouchez is therefore the most active president on Twitter, while Bart De Wever is the most relayed.</p> 
              </div>
            }
            <Row type="flex" gutter={width >= 900 ? 16 : 0} >
              <Col span={ width >= 900 ? 10 : 24} offset={ width >= 900 ? 1 : 0}>
                <h5 style={{ marginLeft: 16 }}>MOST ACTIVE</h5>
                <h3 style={{ marginBottom: width < 900 ? 55 : 88, marginLeft: 16 }}>George-Louis Bouchez</h3>
                <BadgeChart 
                  data={presidents.find(p => p.name === 'GLBouchez')} 
                  maxCount={maxCount} 
                  dateRange={dateRange} 
                  highlight={highlight}
                />
              </Col>
              <Col span={ width >= 900 ? 10 : 24} offset={width >= 900 ? 2 : 0}>
                <h5 style={{ marginLeft: 16 }}>MOST POPULAR</h5>
                <h3 style={{ marginBottom: width < 900 ? 0 : 88, marginLeft: 16 }}>Bart De Wever</h3>
                <BadgeChart 
                  data={presidents.find(p => p.name === 'Bart_DeWever')} 
                  maxCount={maxCount} 
                  dateRange={dateRange} 
                  highlight={highlight}
                />
              </Col>
            </Row>
          </div>
          <Row type="flex" justify="space-between">
            <Col span={width < 900 ? 20 : 12} offset={width < 900 ? 2 : 6}>
              <div style={{ zIndex: 1000, position: 'relative' }}>
                <Section id='tweets' setSectionProgress={setSectionProgress} >
                  <h3>Number of Tweets</h3>
                  <p>Bart De Wever's activity on Twitter started in 2014. Since then, the president of the N-VA tweets little, preferring calibrated messages - <a target = "_ blank" rel = "noopener noreferrer" href = "https: // twitter.com/Bart_DeWever/status/469070925393321984"> sometimes written in third person </a> - over to spontaneous reactions.</p>
                </Section>
                <Section id='commentaires' setSectionProgress={setSectionProgress} >
                  <h3>Number of comments</h3>
                  <p>Georges-Louis Bouchez reacts quickly, on all subjects, whether his interlocutor is elected, journalist or citizen. A strategy totally at the opposite of the one adopted by Bart De Wever, who almost never responds to tweets sent to him.</p>
                </Section>
                <Section id='hours' setSectionProgress={setSectionProgress} >
                  <h3>Time of the day</h3>
                  <p>When does Georges-Louis Bouchez sleep? Probably between midnight and 7 am. In any case, outside of these hours he is almost always on Twitter. On average, the president of the MR has tweeted every three hours for the past three years, weekends and holidays included.</p>
                </Section>
                <Section id='likes' setSectionProgress={setSectionProgress} >
                  <h3>Average number of likes per tweet</h3>
                  <p>The number of likes and retweets are good indicators of how popular a tweet is. Bart De Wever receives on average 18 times more likes than Georges-Louis Bouchez. </p>            
                </Section>
                <Section id='followers' setSectionProgress={setSectionProgress} style={{ marginBottom: '70vh' }} >
                  <h3>Number of followers</h3>
                  <p>Bart De Wever has been present on the national political scene for many years. Georges-Louis Bouchez did not get there until much later. This difference is reflected in their number of followers. The president of the N-VA is followed by more than 156,000 people on Twitter, 9 times more than the French-speaking liberal.</p>
                </Section>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <div className="site-drawer-render-in-current-wrapper">
        {/*<Drawer
          width="30vw"
          title="Top tweets"
          placement="right"
          closable={true}
          onClose={() => setSelectedPresident(null)}
          visible={presidentStats}
          getContainer={false}
          style={{ position: 'absolute' }}
        >
          { (selectedPresident && presidentStats) && 
            <div style={{ textAlign: 'left' }}>
              Les tweets de {selectedPresident.name} ayant eu le plus de succès au cours {selectedYear ? `de l'année ${selectedYear}` : 'des 3 dernières années'}.
              { _([...presidentStats.topLiked, ...presidentStats.topRetweeted, ...presidentStats.topReplyTo]).map('id').uniq().value().map(tweetId => 
                <div key={tweetId}>
                  <TweetEmbed id={tweetId} />
                </div>  
              )}
            </div>
          }
        </Drawer>*/}
        {/*<Row type="flex" justify="start">
          { presidents && _(presidents)
              .orderBy(d => d.full.count + d.full.responsesCount, 'desc')
              .filter(d => !['GLBouchez', 'Bart_DeWever'].includes(d.name))
              .value()
              .map(president => (
                <Col key={president.name} span={width < 900 ? 24 : 8} style={{ cursor: 'pointer' }}>
                  <h2 style={{width: '100%'}}>{presidentInfo[president.name].name} <small>({presidentInfo[president.name].party})</small></h2>
                  <BadgeChart 
                    data={president} 
                    maxCount={maxCount} 
                    dateRange={dateRange} 
                    year={null}//{selectedYear === 'null' ? null : selectedYear}
                  />
                </Col>
              )
            )
          }
        </Row>*/}
      </div>
    </div>
  );
}

export default BadgeChartComponent;
